import { Avatar } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { DetailField } from '../shared/index.js';

/**
 * Break Glass request — HTL V1: requester, 3-col DetailField grid, rose reason
 * callout, incident id row.
 */
function RequestBlock({ detail }) {
  const { t } = useTranslation('work-queues-app');
  if (!detail) return null;
  const { requester } = detail;

  const gridRows = [
    { label: t('breakGlass.partition'), value: detail.partition },
    { label: t('breakGlass.classification'), value: detail.classification },
    { label: t('breakGlass.accessScope'), value: detail.accessScope },
  ].filter((row) => row.value);

  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
        {t('breakGlass.request')}
      </p>

      {requester && (
        <div className="mt-3 flex items-center gap-2.5">
          <Avatar size="sm" initials={requester.initials} alt={requester.name} />
          <div>
            <p className="text-sm font-medium text-content">{requester.name}</p>
            <p className="text-xs text-content-faint">
              {[requester.role, detail.requestedAt].filter(Boolean).join(' · ')}
            </p>
          </div>
        </div>
      )}

      {gridRows.length > 0 && (
        <dl className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {gridRows.map((row) => (
            <DetailField key={row.label} label={row.label} value={row.value} />
          ))}
        </dl>
      )}

      {detail.duration && (
        <dl className="mt-3">
          <DetailField label={t('breakGlass.duration')} value={detail.duration} />
        </dl>
      )}

      {detail.reason && (
        <div className="mt-4 rounded-md border border-rose-500/35 bg-rose-500/[0.08] px-3.5 py-3">
          <p className="text-sm leading-relaxed text-content">{detail.reason}</p>
        </div>
      )}

      {detail.incidentRef && (
        <dl className="mt-3">
          <DetailField label={t('breakGlass.incident')} value={detail.incidentRef} />
        </dl>
      )}
    </div>
  );
}

export default RequestBlock;
